import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"
import {disabledAfter} from "@ui-seeker/core";

import {PRICING_ROUTES, YESTERDAY_DATE} from "@constants"
import { isSystemBusy } from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import { TourProvider } from "@tour"
import {
	PriceDiscountCandlestick, PriceDiscountCountryWise, PriceDiscountSkuEvolution, PriceDiscountTopMarketChanges, PriceDiscountOffersChart, PriceDiscountOffersEvolutionChart,
	PriceDiscountTopDispersionChanges, PriceDiscountStockEvolution
} from "./@Components"
import { resetPricingDiscountData } from "./@signals"
import PriceDiscountnNewFilters from "./NewFilters"



export default function PriceDiscountPage() {

	useEffect(() => {
        return () => resetPricingDiscountData()
    }, [])

	return <PageWrapper
		head={`DIP Insight | ${PRICING_ROUTES.OVERVIEW_TITLE}`}
		title={PRICING_ROUTES.OVERVIEW_TITLE}
		subtitle={PRICING_ROUTES.OVERVIEW_SUBTITLE}
		filters={<PriceDiscountnNewFilters />}
		actions={null}
		tourPageKey="priceDiscount"
		actionProps={{
			dateRangeProps: { shouldDisableDate: disabledAfter(YESTERDAY_DATE) }
		}}
		hasErrors={isSystemBusy.value}
	>
		<Grid container spacing={2}>
			<Grid item xs={4} data-tour="price-discount-offers">
				<PriceDiscountOffersChart />
			</Grid>

			<Grid item xs={8} data-tour="price-discount-country-wise">
				<PriceDiscountCountryWise />
			</Grid>

			<Grid item xs={12} data-tour="price-discount-candlestick">
				<PriceDiscountCandlestick />
			</Grid>

			<Grid item xs={12} x={{ mt: 3}} data-tour="price-discount-top-market">
				<PriceDiscountTopMarketChanges/>
			</Grid>

			<Grid item xs={12} sx={{ mt: 3}} data-tour="price-discount-top-dispersion">
				<PriceDiscountTopDispersionChanges/>
			</Grid>

			<Grid item xs={12}>
				<PriceDiscountSkuEvolution />
			</Grid>

			<Grid item xs={12}>
				<PriceDiscountStockEvolution />
			</Grid>

			<Grid item xs={12}>
				<PriceDiscountOffersEvolutionChart />
			</Grid>
    	</Grid>
	</PageWrapper>
}
